import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AdminGuard } from '../common/AdminGuard';
import { AdminRootComponent } from './admin-root.component';
import { AdminAlertDetailComponent } from './pages/admin-alert-detail/admin-alert-detail.component';
import { AdminAlertComponent } from './pages/admin-alert/admin-alert.component';
import { AdminLandingComponent } from './pages/admin-landing/admin-landing.component';
import { AdminSiteDetailComponent } from './pages/admin-site-detail/admin-site-detail.component';
import { AdminSiteComponent } from './pages/admin-site/admin-site.component';
import { AdminUserDetailComponent } from './pages/admin-user-detail/admin-user-detail.component';
import { AdminUserComponent } from './pages/admin-user/admin-user.component';
import { AdminInventoryComponent } from './pages/admin-inventory/admin-inventory.component';
import { ActionAlertHelpComponent } from './pages/action-alert-help/action-alert-help.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminRootComponent,
    canActivate: [AdminGuard, MsalGuard],
    children: [
      { path: '', component: AdminLandingComponent },
      { path: 'camera/:id', component: AdminSiteDetailComponent },
      { path: 'sites', component: AdminSiteComponent },
      { path: 'sites/:id', component: AdminSiteDetailComponent },
      { path: 'sites/add', component: AdminSiteDetailComponent },
      { path: 'users', component: AdminUserComponent },
      { path: 'users/:id', component: AdminUserDetailComponent },
      { path: 'users/add', component: AdminUserDetailComponent },
      { path: 'alerts', component: AdminAlertComponent },
      { path: 'alerts/help', component: ActionAlertHelpComponent },
      { path: 'alerts/:id', component: AdminAlertDetailComponent },
      { path: 'alerts/add', component: AdminAlertDetailComponent },
      { path: 'inventory', component: AdminInventoryComponent }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule { }
